import { render } from "./Profesionales.vue?vue&type=template&id=51c86f38&ts=true"
import script from "./Profesionales.vue?vue&type=script&lang=ts"
export * from "./Profesionales.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/IAM-PlanCorresponsables/IAM-PlanCorresponsables/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__